import css from './test.module.scss';

import { memo } from 'react';

import { parseNote, prettifyText } from 'core/helpers/text';
import KeyBind from 'core/ui/KeyBind';
import { Icon } from 'core/ui/icons';

type Props = {
  answer: string;
  idx: number;
  disabled: boolean;
  onClick: (idx: number) => void;
  selected?: 'right' | 'wrong';
};

function Option({ answer, selected, idx, onClick, disabled }: Props) {
  return (
    <button
      className={css.option}
      data-selected={selected || undefined}
      disabled={disabled}
      onClick={() => onClick(idx)}
    >
      <span className={css.optionIdx}>{idx + 1}</span>
      {parseNote(answer).map(
        (piece, idx) =>
          (disabled || piece.type === 'regular') && (
            <span key={idx} className={css[`${piece.type}Text`]}>
              {piece.type === 'secret' && (
                <Icon icon="Question" className={css.hintIcon} />
              )}
              {prettifyText(piece.v)}
            </span>
          )
      )}
      <KeyBind
        disabled={disabled}
        kkb={`Digit${idx + 1}`}
        onKeyDown={() => onClick(idx)}
      />
    </button>
  );
}

export default memo(Option);
